import '../fesd/fesd'
import '../../sass/investor/investor.sass'

$(function(){
  const hoverFunc = () => {
    $('.rect-nav:not(.no-item) a').hover(function() {
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
    }, function() {
      $(this).siblings().removeClass('active');
    });
  };

  hoverFunc();
});